<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { faPlus } from '@fortawesome/duotone-regular-svg-icons'
import useGroupsStore from '~/stores/groups'
import Button from '~/components/ui/Button.vue'
import SettingsGroupLine from '~/components/settings/SettingsGroups/SettingsGroupLine.vue'

const emit = defineEmits(['openGroup'])

const {
  basisGroups,
  teachingGroups,
  otherGroups,
} = storeToRefs(useGroupsStore())

const { t } = useI18n()
</script>

<template>
  <div>
    <div
      v-if="basisGroups.length"
      class="py-6"
    >
      <h3
        class="mb-2 text-base font-medium tracking-wide uppercase"
        v-text="t('groups.types.basis')"
      />
      <ul class="flex flex-col gap-4">
        <li
          v-for="group in basisGroups"
          :key="group.groupId"
        >
          <SettingsGroupLine
            :group="group"
            @open-group="emit('openGroup', group)"
          />
        </li>
      </ul>
    </div>

    <div
      v-if="teachingGroups.length"
      class="py-6"
    >
      <h3
        class="mb-2 text-base font-medium tracking-wide uppercase"
        v-text="t('groups.types.teaching')"
      />
      <ul class="flex flex-col gap-4">
        <li
          v-for="group in teachingGroups"
          :key="group.groupId"
        >
          <SettingsGroupLine
            :group="group"
            @open-group="emit('openGroup', group)"
          />
        </li>
      </ul>
    </div>

    <div class="py-6">
      <div class="mb-3 flex items-center justify-between">
        <h3
          class="text-base font-medium tracking-wide uppercase"
          v-text="t('groups.types.other')"
        />
        <Button @click="emit('openGroup', {})">
          <font-awesome-icon :icon="faPlus" />
          {{ t('groups.newGroup') }}
        </Button>
      </div>
      <ul
        v-if="otherGroups.length"
        class="grid grid-cols-1 gap-4 md:grid-cols-2"
      >
        <li
          v-for="group in otherGroups"
          :key="group.groupId"
          class="animate-fade"
        >
          <SettingsGroupLine
            :group="group"
            @open-group="emit('openGroup', group)"
          />
        </li>
      </ul>
      <p
        v-else
        v-text="t('groups.noLocalGroups')"
      />
    </div>
  </div>
</template>
